export enum DatabaseItemState {
    Archived = 'archived',
    Published = 'published',
    PendingSubmission = 'pending-submission',
    Draft = 'draft',
}
